import { Navigate, Route, Routes } from 'react-router'
import { NotFound } from '../common/NotFound'
import { ROUTES, SUB_PATH } from '../../utils/routes'
import { AdInsertionPage } from './AdInsertionPage'
import { EditAdServer } from './adServer/Edit'
import { DemoPage } from './demo/DemoPage'
import { AdAuditLog } from './AdAuditLog'
import { EditAdCreative } from './adCreative/Edit/Edit'
import { AdCreativeList } from './adCreative/List'
import { AdPodList } from './adPod/List'
import { EditAdPod } from './adPod/Edit/Edit'
import { ViewAdBreak } from './adBreak/View/View'
import { AdBreakList } from './adBreak/List'
import { AdServerList } from './adServer/List'

export const AdInsertion = () => {
  return (
    <Routes>
      <Route path={`adServers/${SUB_PATH.UPDATE}`} element={<EditAdServer />} />
      <Route path={`adServers/${SUB_PATH.NEW}`} element={<EditAdServer />} />
      <Route path={`adServers/${SUB_PATH.COPY}`} element={<EditAdServer />} />
      <Route path={`adServers`} element={<AdServerList />} />
      <Route path={`adCreatives`} element={<AdCreativeList />} />
      <Route path={`adCreatives/${SUB_PATH.UPDATE}`} element={<EditAdCreative />} />
      <Route path={`adCreatives/${SUB_PATH.NEW}`} element={<EditAdCreative />} />
      <Route path={`adPods`} element={<AdPodList />} />
      <Route path={`adPods/${SUB_PATH.UPDATE}`} element={<EditAdPod />} />
      <Route path={`adPods/${SUB_PATH.NEW}`} element={<EditAdPod />} />
      <Route path={`adBreaks`} element={<AdBreakList />} />
      <Route path={`adBreaks/history`} element={<AdBreakList />} />
      <Route path={`adBreaks/${SUB_PATH.VIEW}`} element={<ViewAdBreak />} />
      <Route path={`demo`} element={<DemoPage />} />
      <Route path={`adAudit`} element={<AdAuditLog />} />
      <Route path={`adServers`} element={<Navigate to={ROUTES.adInsertion} />} />
      <Route path={`adInsertion`} element={<Navigate to={ROUTES.adInsertion} />} />
      <Route index element={<AdInsertionPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
